import React, { useEffect, useState } from "react";
import Link from "next/link";
import { CircularProgress, Grid } from "@mui/material";
import API from "@unisearch/helpers/api";
import Select from "react-select";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import styles from "./form.module.scss";
import { getGeoInfo, swalError, swalSuccess } from "@unisearch/helpers";
import PhoneInput from "react-phone-input-2";
import Cookies from "js-cookie";

const customStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: "52px",
    boxShadow: state.isFocused
      ? "0px 104px 217px #f1f5fd, 0px 13px 27px #ebeef6"
      : "0px 104px 217px #f1f5fd, 0px 13px 27px #ebeef6",
    "&:hover": { borderColor: "none" }, // border style on hover
    borderColor: state.isFocused ? "#fff" : "#fff",
    backgroundColor: "#fff",
    fontSize: "15px",
    border: "1px solid #fff",
    padding: "12px 0px",
    marginTop: "10px",
    borderRadius: "10px",
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    paddingLeft: "15px",
  }),
  placeholder: (provided, state) => ({
    ...provided,
    fontSize: "14px",
    color: "#c4c4c4",
  }),
  option: (provided, state) => ({
    ...provided,
    cursor: "pointer",
    fontSize: "14px",
    transition: "all 0.3s",
    color: state.isSelected ? "#F47F20" : "#B5B5C3",
    backgroundColor: state.isSelected
      ? "#F5F6FC"
      : state.isFocused
      ? "#fff"
      : provided.backgroundColor,
    "&:hover": {
      backgroundColor: "#F5F6FC",
      color: "#F47F20",
    },
  }),
};

const init = {
  countryName: "",
  institutionName: "",
  designation: "",
  contactName: "",
  email: "",
  phone: "",
  content: "",
};

export const UniPageBookingForm = () => {
  const [countries, setCountries] = useState([]);
  const [formData, setFormData] = useState(init);
  const [loading, setLoading] = useState(false);
  const [defaultCountryCode, setDefaultCountryCode] = useState();
  useEffect(() => {
    setTimeout(() => {
      if (Cookies.get("default_country")) {
        setDefaultCountryCode(Cookies.get("default_country"));
      }
    }, 1500);
  }, [defaultCountryCode]);

  useEffect(() => {
    const getCountryList = async () => {
      await API.get("/public/country/dropdown").then((res) => {
        if (!res.error) {
          const { data } = res;

          setCountries(() =>
            data.map((item) => {
              return {
                value: item.label,
                label: item.label,
              };
            })
          );
        }
      });
    };
    getCountryList();
  }, []);

  // const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  const validationSchema = Yup.object().shape({
    countryName: Yup.string().required("Country Name Required"),
    institutionName: Yup.string().required("Institution name is Required"),
    designation: Yup.string().required("Designation is Required"),
    contactName: Yup.string().required("Contact name is Required"),
    phone: Yup.string().required("Phone is Required"),
    // phone: Yup.string().matches(phoneRegExp, "Contact number is not valid"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Field is required"),
  });

  const storeBook = async (values, action) => {
    setLoading(true);
    await API.post("/public/university-booking", values)
      .then((res) => {
        if (!res.error) {
          swalSuccess(res.message);
          setLoading(false);
          action.resetForm();
        } else {
          swalError("Something went wrong");
        }
      })
      .catch((error) => {
        console.log(error);
        swalError("Something went wrong");
      });
  };

  return (
    <section className={styles.section_form}>
      <div className="container">
        <Formik
          initialValues={formData}
          enableReinitialize={true}
          validationSchema={validationSchema}
          onSubmit={(values, action) => {
            storeBook(values, action);
          }}
        >
          {({ handleSubmit, setFieldValue, errors, values, touched }) => (
            <Form className="form">
              <div className={styles.form}>
                <Grid container spacing={4}>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    className={styles.form_group}
                  >
                    <label>
                      Country <span className={styles.important}>*</span>
                    </label>
                    <Select
                      placeholder="Select Country"
                      styles={customStyles}
                      name="countryName"
                      defaultValue={values.countryName}
                      options={countries ?? []}
                      onChange={(e) => {
                        setFieldValue("countryName", e.value);
                      }}
                    />
                    {errors.countryName && touched.countryName && (
                      <p className={`${styles.error_msg} error`}>
                        {errors.countryName}
                      </p>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    className={styles.form_group}
                  >
                    <label>
                      Institution Name{" "}
                      <span className={styles.important}>*</span>
                    </label>
                    <input
                      value={values.institutionName}
                      type="text"
                      placeholder="Institution Name"
                      onChange={(e) => {
                        setFieldValue("institutionName", e.target.value);
                      }}
                    />
                    {errors.institutionName && touched.institutionName && (
                      <p className={`${styles.error_msg} error`}>
                        {errors.institutionName}
                      </p>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    className={styles.form_group}
                  >
                    <label>
                      Designation <span className={styles.important}>*</span>
                    </label>
                    <input
                      value={values.designation}
                      type="text"
                      placeholder="Designation"
                      onChange={(e) => {
                        setFieldValue("designation", e.target.value);
                      }}
                    />
                    {errors.designation && touched.designation && (
                      <p className={`${styles.error_msg} error`}>
                        {errors.designation}
                      </p>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    className={styles.form_group}
                  >
                    <label>
                      Contact Name <span className={styles.important}>*</span>
                    </label>
                    <input
                      value={values.contactName}
                      type="text"
                      placeholder="Contact Name"
                      onChange={(e) => {
                        setFieldValue("contactName", e.target.value);
                      }}
                    />
                    {errors.contactName && touched.contactName && (
                      <p className={`${styles.error_msg} error`}>
                        {errors.contactName}
                      </p>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    className={styles.form_group}
                  >
                    <label>
                      Email <span className={styles.important}>*</span>
                    </label>
                    <input
                      value={values.email}
                      type="text"
                      placeholder="Email"
                      onChange={(e) => {
                        setFieldValue("email", e.target.value);
                      }}
                    />
                    {errors.email && touched.email && (
                      <p className={`${styles.error_msg} error`}>
                        {errors.email}
                      </p>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    className={styles.form_group}
                  >
                    <label>
                      Phone Number <span className={styles.important}>*</span>
                    </label>
                    <PhoneInput
                      placeholder="Phone Number"
                      country={defaultCountryCode ?? "a"}
                      countryCodeEditable={false}
                      value={values.phone}
                      onChange={(_value, country, _event, formattedValue) => {
                        setFieldValue("phone", formattedValue);
                      }}
                      className={styles.phoneInput}
                    />
                    {errors.phone && touched.phone && (
                      <p className={`${styles.error_msg} error`}>
                        {errors.phone}
                      </p>
                    )}
                  </Grid>
                  <Grid item xs={12} className={styles.form_group}>
                    <label>Any Additional Comment</label>
                    <textarea
                      value={values.content}
                      placeholder="Type Here"
                      rows={5}
                      onChange={(e) => {
                        setFieldValue("content", e.target.value);
                      }}
                    ></textarea>
                  </Grid>
                </Grid>
                <p>
                  By submitting your info in the form above, you agree to our{" "}
                  <Link legacyBehavior href="/terms-and-conditions">
                    <a>Terms of Use</a>
                  </Link>{" "}
                  . We may use this info to contact you and/or use data from
                  third parties to personalize your experience.
                </p>
                <div className={styles.action_btn}>
                  <button
                    disabled={loading}
                    className="btn btn-xl btn-secondary "
                  >
                    {loading && (
                      <CircularProgress size="20px" color="inherit" />
                    )}
                    Submit
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </section>
  );
};

export default UniPageBookingForm;
